export default __webpack_public_path__ + "static/media/Logo_Color_RGB.447bbd0e.png";